// @flow

import QuickLinkTiles from './QuickLinkTiles';
import QuickLinksLite from './QuickLinksLite';

/** The version of quick links that show on mobile and homepage (and possibly other pages in the future). */
export default QuickLinkTiles;

/** The version of quick links that show in the fixed header after scrolling on desktop (currently only on home) */
export { QuickLinksLite };
